import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Home from "@/pages/Home";
import Dashboard from "@/pages/Dashboard";
import PolicyAnalysis from "@/pages/PolicyAnalysis";
import AskAI from "@/pages/AskAI";
import MyPolicies from "@/pages/MyPolicies";
import Chat from "@/pages/Chat";
import Terms from "@/pages/Terms";
import AdminPanel from "@/pages/AdminPanel";
import ResetPassword from "@/pages/ResetPassword";
import { AuthProvider } from "@/context/AuthContext";
import { getSessionId } from "@/lib/session";
import "@/lib/authApi";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

// Masked visibility so we can verify the env var made it into the bundle.
// Prints e.g. "991090343575…m" or "(EMPTY — REACT_APP_GOOGLE_CLIENT_ID not set)".
if (typeof window !== "undefined") {
  const masked =
    GOOGLE_CLIENT_ID.length >= 12
      ? `${GOOGLE_CLIENT_ID.slice(0, 12)}…${GOOGLE_CLIENT_ID.slice(-4)} (len=${GOOGLE_CLIENT_ID.length})`
      : "(EMPTY — REACT_APP_GOOGLE_CLIENT_ID not set at build time)";
  // eslint-disable-next-line no-console
  console.info(`[KYP] Google client id: ${masked}`);
}

function App() {
  useEffect(() => {
    // Eagerly create the anonymous visitor session id on first paint so it
    // persists in localStorage from the moment the user lands on any page.
    getSessionId();
  }, []);

  return (
    <div className="App">
      <HelmetProvider>
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          <AuthProvider>
            <BrowserRouter>
              <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/policies" element={<MyPolicies />} />
              <Route path="/policy/:id" element={<PolicyAnalysis />} />
              <Route path="/ask" element={<AskAI />} />
              <Route path="/chat/:uploadId" element={<Chat />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/admin" element={<AdminPanel />} />
                <Route path="/admin/feedback" element={<AdminPanel />} />
              </Routes>
            </BrowserRouter>
          </AuthProvider>
        </GoogleOAuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
